<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey" :submit="submit" :status="status" labelBack="Atrás"
    :urlSendNotification="urlSendNotification">
    <ValidationObserver ref="validator" v-slot="{ errors }">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider ref="address" rules="required" v-slot="{ errors }">
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.address" label="Lugar"
                  prepend-inner-icon="fas fa-file"></v-text-field>
              </ValidationProvider>
              <span style="color: #ff5252;">{{ customerrors ? customerrors.errors?.msg : '' }}</span>
              <GoogleMapLoader v-on:select="changeAddress" :show-map="false" style="height: 300px"
                :sendCoordinates="sendCoordinates" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="unit" rules="" v-slot="{ errors }">
                <v-text-field :error-messages="errors" type="text" v-model="data.unit" label="Unidad"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="province_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.province_id" :items="provinces" item-text="name"
                  item-value="id" label="Provincia"></v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="city_id" rules="" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.city_id" :items="cities" item-text="name"
                  item-value="id" label="Ciudad"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="latitude" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" v-model.number="data.latitude" type="Number" label="Latitud"
                  prepend-inner-icon="fas fa-file"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="longitude" rules="required" v-slot="{ errors }">
                <v-text-field :error-messages="errors" type="Number" v-model.number="data.longitude" label="Longitud"
                  prepend-inner-icon="fas fa-file"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="status" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.status" label="Estado" :items="status_types">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="size_spot_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.size_spot_id" :items="size_spots" item-text="title"
                  item-value="id" label="Tamaño"></v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="type_spot_id" rules="required" v-slot="{ errors }">
                <v-select :error-messages="errors" v-model="data.type_spot_id" :items="type_spots" item-text="name"
                  item-value="id" label="Tipo"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="verified" rules="" v-slot="{ errors }">
                <v-checkbox :error-messages="errors" label="Verified" v-model.number="data.verified">
                </v-checkbox>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="deleted" rules="" v-slot="{ errors }">
                <v-checkbox v-model="data.deleted" label="Eliminado"></v-checkbox>
              </ValidationProvider>
            </v-col>
            <v-col>
              <v-checkbox v-model="data.home_constancy" label="Constancia Domicilio"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="data.has_sticker" label="Cartel Colocado"></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="description" rules="" v-slot="{ errors }">
                <v-textarea :error-messages="errors" v-model="data.description" label="Descripción"
                  rows="8"></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg" placeholder="Imagen de Spots"
                  prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedPicture">
                </Upload>
                <v-img :src="picture_poster" width="200" style="margin: auto"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              Fotos Poster
            </v-col>
          </v-row>
          <div class="images_poster">
            <v-row>
              <v-col v-for="(item, i) in images_poster" :key="'img_' + i" class="d-flex child-flex" cols="3">
                <a :href="item" target="_blank">
                  <img :src="item" alt="" title="" class="img-default" />
                </a>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import GoogleMapLoader from "@/components/maps/GoogleMapLoader";
//import VueLightbox from 'vue-lightbox'
export default {
  mixins: [CrudFormMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    CrudForm,
    GoogleMapLoader,
    Upload,
    //VueLightbox
  },
  computed: {
    ...mapState({
      status: (state) => state.Spots.status,
      customerrors: (state) => state.Spots.customerrors,
      type_spots: (state) => state.Type_spots.list,
      size_spots: (state) => state.Size_spots.list,
      provinces: (state) => state.Provinces.list,
      cities: (state) => state.Cities.list,
    }),
  },
  mounted() { },
  async created() {
    const self = this;
    let filters = {};
    this.urlSendNotification = "";

    if (this.$route.params.user_id) {
      this.data.user_id = this.$route.params.user_id;
      filters.user_id = this.$route.params.user_id;
    }
    if (this.$route.params.id) {
      await self.$store
        .dispatch("Spots/show", this.$route.params.id)
        .then(async (val) => {
          this.data.type_spot_id = val.type_spot;
          await this.$store.dispatch("Cities/getListAll", { enable: true, province_id: val.province_id });
        });

      filters.spot_id = this.$route.params.id;
      const posters = await self.$store.dispatch("Posters/getListAll", {
        spot_id: filters.spot_id,
      });
      if (posters && posters.length > 0) {
        const poster = posters[0];
        const valid_photos = poster.photos.filter((item) => item.photo);
        this.images_poster = valid_photos.map((item) => item.photo);
      }

      this.urlSendNotification =
        "/admin/users/" +
        this.$route.params.user_id +
        "/message/send/" +
        this.$route.params.id +
        "?name=" +
        (this.data.address ? this.data.address : "");
    }
    await self.$store.dispatch("Spots/getListAll", filters);
    await self.$store.dispatch("Type_spots/getListAll", filters);
    await self.$store.dispatch("Size_spots/getListAll", {});
    await self.$store.dispatch("Provinces/getListAll", { enable: true });
  },
  data() {
    return {
      images_poster: [],
      parentStoreName: "Users",
      parentUrlKey: "user_id",
      storeName: "Spots",
      title: "Spots",
      status_types: [
        "in_use",
        "available",
        "unavailable",
        "verification_rejected",
      ],
      //size_types: ['standart','compact', 'medium','big','xl'],
      availability_types: ["full_time", "part_time", "my_time"],
      filteredAttributes: ["picture"],
      picture_poster: "",
      data: {
        user_id: "",
        address: "",
        latitude: "",
        longitude: "",
        location: "",
        size_spot_id: "",
        status: "",
        availability: "",
        type_spot_id: "",
        home_constancy: false,
        verified: false,
        deleted: false,
        description: "",
        unit: "A",
        //is_automatic: false,
        picture: undefined,
        province_id: "",
        city_id: "",
        has_sticker: false
      },
      time_to: "",
      time_from: "",
      menu_time_to: false,
      menu_time_from: false,
      urlSendNotification: "",
    };
  },
  watch: {
    time_to(val) {
      this.time_to = val;
      this.data.time_to = this.formatDateForSave(val);
    },
    time_from(val) {
      this.time_from = val;
      this.data.time_from = this.formatDateForSave(val);
    },
    async 'data.province_id'(val) {
      this.data.city_id;
      await this.$store.dispatch("Cities/getListAll", { enable: true, province_id: val });
    },
  },
  methods: {
    onCreate(data) {
      this.data.size_spot_id = data.size;
    },
    sendCoordinates(lat, lng) {
      this.data.latitude = lat;
      this.data.longitude = lng;
    },
    changeAddress(val) {
      this.data.address = val;
    },
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture_poster = fr.result;
      };
      fr.onerror = function () {
        self.picture_poster = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
  },
};
</script>
